import React from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
class Sitemap extends React.Component {
  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Sitemap | LA Language Academy Australia</title>
          <meta name="description" content="Welcome to our sitemap. Here, you'll find all the links to our website's pages, making navigation quick & easy. Explore the sections to find what you need." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/sitemap`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="Sitemap | LA Language Academy Australia" />
          <meta name="twitter:description" content="Welcome to our sitemap. Here, you'll find all the links to our website's pages, making navigation quick & easy. Explore the sections to find what you need." />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/sitemap`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Sitemap | LA Language Academy Australia" />
          <meta property="og:description" content="Welcome to our sitemap. Here, you'll find all the links to our website's pages, making navigation quick & easy. Explore the sections to find what you need." />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </Helmet>
        <Header />
        <div className="hero-section mt-80">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="hero-content">
                  <h1 className="primary-heading">
                    Site map
                  </h1>
                  <p className="sub-heading">
                  Welcome to our sitemap. Here, you'll find all the important links to our website’s pages, making navigation quick and easy. Explore the sections to find what you need.
                  </p>
                  <div className="text-center text-md-start">
                    <Link to="/auth/register" className="primary-btn">
                      REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="hero-img-wrapper">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/bannerImg.png"
                    alt="LA"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <section id="pte-modules" className="sitemap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <section id="la_info" className="sitemap_section">
                  <h2>Information</h2>
                  <div className="row">
                    <div className="col-md-12">
                      <ul>
                        <li>
                          <a target="_blank" className="sitemap_href" href="/">
                            Home
                          </a>
                        </li>
                        {/*<li><Link target="_blank" to="/video-courses">Video Course</Link></li>*/}
                        <li>
                          <Link target="_blank" to="/admin/mock">
                            Mock Test
                          </Link>
                        </li>
                        <li>
                          <Link target="_blank" to="/admin/test-material">
                            Study Material
                          </Link>
                        </li>
                        <li>
                          <Link
                            target="_blank"
                            className="sitemap_href"
                            to="/term"
                          >
                            Terms
                          </Link>
                        </li>
                        <li>
                          <Link
                            target="_blank"
                            className="sitemap_href"
                            to="/refund"
                          >
                            Refund Policy
                          </Link>
                        </li>
                        <li>
                          <Link target="_blank" to="/about">
                            About Us
                          </Link>
                        </li>
                        <li>
                          <Link target="_blank" to="/contact">
                            Contact
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
                <section id="la_courses" className="sitemap_section">
                  <h2>Courses</h2>
                  <div className="row">
                    <div className="col-md-12">
                      <ul>
                        <li>
                          <a className="test1">PTE </a>
                          <ul className="ml-5">
                            <li>
                              <a target="_blank" href="/pte-online-coaching">
                                PTE Online Coaching
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                href="/pte-coaching-classes-parramatta"
                              >
                                PTE Parramatta
                              </a>
                            </li>
                            <li>
                              <a target="_blank" href="/pte-coaching-sydney">
                                PTE Sydney
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a className="test1">NAATI </a>
                          <ul className="ml-5">
                            <li>
                              <a
                                target="_blank"
                                href="/naati-ccl-online-coaching"
                              >
                                NAATI Online Coaching
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                href="/naati-coaching-classes-parramatta"
                              >
                                NAATI Parramatta
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                href="/naati-ccl-coaching-sydney"
                              >
                                NAATI Sydney
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a className="test1">IELTS </a>
                          <ul className="ml-5">
                            <li>
                              <a target="_blank" href="/ielts-online-coaching">
                                IELTS Online Coaching
                              </a>
                            </li>
                            <li>
                              <a
                                target="_blank"
                                href="/ielts-coaching-parramatta"
                              >
                                IELTS Parramatta
                              </a>
                            </li>
                            <li>
                              <a target="_blank" href="/ielts-coaching-sydney">
                                IELTS Sydney
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
                <section
                  id="login_register"
                  className="sitemap_section sitemap_last_section"
                >
                  <h2>Login/Register</h2>
                  <div className="row">
                    <div className="col-md-12">
                      <ul>
                        <li>
                          <Link
                            target="_blank"
                            className="sitemap_href"
                            to="/auth/login"
                          >
                            Login
                          </Link>
                        </li>
                        <li>
                          <Link
                            target="_blank"
                            className="sitemap_href"
                            to="auth/register"
                          >
                            Register
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
              <div className="col-md-6">
                <section id="la_resources" className="sitemap_section">
                  <h2>Resourses</h2>
                  <div className="row">
                    <div className="col-md-12">
                      <ul>
                        <li>
                          <a
                            target="_blank"
                            className="sitemap_href"
                            href={`https://www.languageacademy.com.au/a/videos/showvideo`}
                          >
                            Tutorial Videos
                          </a>
                        </li>
                        <li>
                          <a className="sitemap_href" href="#">
                            Practice Material
                          </a>
                          <ul>
                            <li>
                              <a
                                className="test1"
                                href="/pte-speaking-test-practice-material"
                              >
                                Speaking{" "}
                              </a>
                              <ul className="ml-5">
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/1"
                                  >
                                    Read Aloud
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/2"
                                  >
                                    Repeat Sentence
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/3"
                                  >
                                    Describe Image
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/4"
                                  >
                                    Re-tell Lecture
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/5"
                                  >
                                    Answer Short Questions
                                  </a>
                                </li>
                                 <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/22"
                                  >
                                    Summarize Group Discussion
                                  </a>
                                </li>
                                 <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/21"
                                  >
                                    Respond To A Situation
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a
                                className="test2"
                                href="/pte-writing-test-practice-material"
                              >
                                Writing{" "}
                              </a>
                              <ul className="ml-5">
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/6"
                                  >
                                    Summarize Written Text
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/7"
                                  >
                                    Write Essay
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a
                                className="test3"
                                href="/pte-reading-test-practice-material"
                              >
                                Reading{" "}
                              </a>
                              <ul className="ml-5">
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/8"
                                  >
                                    Multiple Choice, Single Answer
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/9"
                                  >
                                    Multiple Choice, Multiple Answers
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/10"
                                  >
                                    Reorder Paragraph
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/11"
                                  >
                                    Fill In The Blanks (Drop-Down)
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/12"
                                  >
                                    Fill In The Blanks (Drag & Drop)
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a
                                className="test4"
                                href="/pte-listening-test-practice-material"
                              >
                                Listening{" "}
                              </a>
                              <ul className="ml-5">
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/13"
                                  >
                                    Summarize Spoken Text
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/14"
                                  >
                                    Multiple Choice, Multiple Answers
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/15"
                                  >
                                    Fill In The Blanks (Type In)
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/16"
                                  >
                                    Highlight Correct Summary
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/17"
                                  >
                                    Multiple Choice, Single Answer
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/18"
                                  >
                                    Select Missing Words
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/19"
                                  >
                                    Highlight Incorrect Words
                                  </a>
                                </li>
                                <li>
                                  <a
                                    target="_blank"
                                    href="/admin/questionList/0/20"
                                  >
                                    Write From Dictation
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
}

export default Sitemap;
